// メッセージMap
export const MessageMap = {
    "evaluation_score": "今回評価設定",
    "evaluation_comment": "評価コメント",
};